import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';

function fetch(campaignId, campaignTypeRef, channelId) {
  return ajaxService
    .get(`/api/channel/listPersistentDCs/${channelId}.json`, {
      campaignId,
      coTypeRef: campaignTypeRef,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract);
}

export default {
  fetch,
};
